'use client';

import styled from '@emotion/styled';
import { ArrowIconLight, ContentWrap, Css, Responsive } from '@/ui';
import defaultHeaderImage from '../../../assets/defaultHeaderImage.jpg';
import defaultBackgroundImagemobile from '../../../assets/defaultBackgroundImageMobile.jpg';
import { Color } from '../../../styles/Color';
import LinkButton from '../../../components/common/button/LinkButton';
import { Topbar } from '../../../components/common/top-bar/Topbar';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { FONT_FAMILY_AVENIR_NEXT } from '../../../styles/Font';
import { getHeadingStyle } from '../../../styles/utils/getHeadingStyle';
import { theme } from '../../../styles/theme';

export default function NotFoundPage() {
	return (
		<StyledContainer>
			<ContentWrap>
				<Topbar />
			</ContentWrap>
			<NotFoundWrapper>
				<NotFoundInnerWrapper>
					<StyledPill>404</StyledPill>
					<StyledHeader>Page not found</StyledHeader>
					<StyledParagraph>
						We couldn&apos;t find the page you were looking for. Please check
						your link or
					</StyledParagraph>
					<LinkButton
						href={PageRoutes.Home}
						icon={<ArrowIconLight />}
						buttonType="text"
					>
						Return to Home
					</LinkButton>
				</NotFoundInnerWrapper>
			</NotFoundWrapper>
		</StyledContainer>
	);
}

const StyledContainer = styled.div`
	background: url(${defaultHeaderImage}) no-repeat center center fixed;
	background-size: cover;
	min-height: 100vh;

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		background-image: url(${defaultBackgroundImagemobile});
		background-position: center bottom;
	}
`;

const NotFoundWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	min-height: 65vh;
`;

const NotFoundInnerWrapper = styled.div`
	max-width: 280px;
`;

const StyledHeader = styled.h1`
	${getHeadingStyle(theme, 'h4')}
	color: ${Color.PrimaryBlue};
	margin-top: ${Css.pxToRem(25)};
	margin-bottom: 0;
`;

const StyledParagraph = styled.p`
	margin-bottom: ${Css.pxToRem(10)};
	line-height: 22.3px;
	letter-spacing: ${Css.pxToRemFromTheme(0.64)};
`;

const StyledPill = styled.span`
	background: ${Color.PrimaryWhite};
	border-radius: 60px;
	gap: ${Css.pxToRem(10)};
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(24)};
	font-weight: 700;
	color: ${Color.PrimaryBlue};
	letter-spacing: 0.1px;
	font-family: ${FONT_FAMILY_AVENIR_NEXT};
`;
